export default __webpack_public_path__ + "static/media/pericles-outlined-blanco.6842667a.png";